import { z } from 'zod'
import { ProviderId } from '../enums'
import { Instant } from './primitives'

export const PROVIDER_HEALTHS = ['healthy', 'failing', 'circuit_open', 'recovering'] as const
export const ProviderHealth = z.enum(PROVIDER_HEALTHS)
export type ProviderHealth = z.infer<typeof ProviderHealth>

export const PROVIDER_ROLES = ['primary', 'secondary', 'decision'] as const
export const ProviderRole = z.enum(PROVIDER_ROLES)
export type ProviderRole = z.infer<typeof ProviderRole>

export const ProviderStatus = z.object({
  provider: ProviderId,
  role: ProviderRole,
  health: ProviderHealth,
  failureCount: z.number().int().nonnegative(),
  lastFailureAt: Instant.nullable(),
  lastFailureKind: z.string().min(1).nullable(),
  openedAt: Instant.nullable(),
  probeAfter: Instant.nullable(),
})
export type ProviderStatus = z.infer<typeof ProviderStatus>

export const ProviderOverview = z.object({
  answering: ProviderId.nullable(),
  classifying: ProviderId.nullable(),
  providers: z.array(ProviderStatus),
})
export type ProviderOverview = z.infer<typeof ProviderOverview>
